export default __webpack_public_path__ + "static/media/blonde-man-side-twist.cf1edfef.jpg";